export const ROLES = {
  STUDENT: 'student',
  COMPANY: 'company',
  ADMIN: 'admin',
};

export const STATUS = {
  APPLIED: 'Applied',
  UNDER_REVIEW: 'Under Review',
  SHORTLISTED: 'Shortlisted',
  INTERVIEW: 'Interview Scheduled',
  SELECTED: 'Selected',
  REJECTED: 'Rejected',
};

export const JOB_TYPES = [
  'Full Time',
  'Part Time',
  'Internship',
  'Contract',
  'Remote'
];
